var React = require('react');

function CssInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"css.inline","d":"M1.5,0H92.365L84.1,93.3,46.833,103.844,9.773,93.3ZM75.446,19.094l-57.028-.013.922,11.345,43.81.009-1.1,11.752H33.316L34.354,53.32H61.1L59.519,68.563,46.928,72.042l-12.79-3.5-.813-9.13H22.031l1.255,16.68,23.646,7.369,23.248-6.62L75.446,19.1Z","transform":"translate(-1.5)","fill":"#770ff3"}));
}

CssInline.defaultProps = {"className":"icon","width":"90.865","height":"103.844","viewBox":"0 0 90.865 103.844"};

module.exports = CssInline;

CssInline.default = CssInline;
